import { render, staticRenderFns } from "./Instance.vue?vue&type=template&id=6a015b39&"
import script from "./Instance.vue?vue&type=script&lang=js&"
export * from "./Instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports